import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7d31690"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col m-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "sub-plan-name" }
const _hoisted_6 = { class: "col-4 sub-col-right" }
const _hoisted_7 = { class: "sub-sales-cell-price" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-7" }
const _hoisted_11 = { class: "sub-changed-box" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "row sub-plan-header-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8 sub-plan-header-col" }, null, -1))
const _hoisted_16 = { class: "col-4 sub-plan-header-col sub-col-right" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-8" }
const _hoisted_20 = { class: "col-4 sub-col-right" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "sub-sales-cell-price" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "sub-next-payment" }
const _hoisted_27 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_28 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_modal = _resolveComponent("loading-modal")!
  const _component_billing_info = _resolveComponent("billing-info")!
  const _component_status_block = _resolveComponent("status-block")!
  const _component_collapsable_container = _resolveComponent("collapsable-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading_modal, { enabled: _ctx.loadingShow }, null, 8, ["enabled"]),
    _createVNode(_component_collapsable_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, "Plan: " + _toDisplayString(_ctx.user.subscription?.plan?.name), 1),
                _createElementVNode("a", {
                  class: "sub-button-like-link ms-3",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSubChangeBlock')))
                }, "change your plan")
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.totalAmountFormatted), 1)
              ])
            ]),
            (_ctx.user.subscription?.state === 'canceled')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, " Your subscription is set to expire on " + _toDisplayString(_ctx.user.subscription?.endFormatted) + ". ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        class: "sub-button-like-link",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reactivateSubscription && _ctx.reactivateSubscription(...args)))
                      }, "I changed my mind. Do not cancel.")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.montlyOrAnnual()) + " TOTAL", 1)
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_billing_info, {
                  onToggleBillingInfoChangeBlock: _cache[2] || (_cache[2] = ($event: any) => (
                _ctx.$emit('toggleBillingInfoChangeBlock')
              ))
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.totalAmountFormatted), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, " Next payment is on " + _toDisplayString(_ctx.user.subscription?.endFormatted), 1)
                  ])
                ])
              ])
            ]),
            (_ctx.user.subscription?.state === 'active')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("a", {
                      class: "cancel-subscription-button",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelSubscription && _ctx.cancelSubscription(...args)))
                    }, "Cancel Subscription")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_status_block, {
              class: "mt-3",
              message: _ctx.errorMessage
            }, null, 8, ["message"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}